import { FinanceRate } from '@kanda-libs/ks-frontend-services';

import { FINANCE_ORDER } from './constants';
import { SplitKey } from './useAPRs';

export const checkFinanceType = (
  typeString: string,
): FinanceRate['apr_type'] => {
  if (typeString === 'INTEREST_FREE') return 'INTEREST_FREE';
  if (typeString === 'INTEREST_BEARING') return 'INTEREST_BEARING';
  if (typeString === 'BUYNOW_PAYLATER') return 'BUYNOW_PAYLATER';
  return undefined;
};

export const sortSplitKeys = (splitKeys: SplitKey[]): SplitKey[] =>
  splitKeys.sort((key1, key2) => {
    const typeOrder =
      FINANCE_ORDER.indexOf(key1.financeType) -
      FINANCE_ORDER.indexOf(key2.financeType);
    if (typeOrder !== 0) return typeOrder;
    return parseInt(key1.apr, 10) - parseInt(key2.apr, 10);
  });
